import { render } from "./behno-press.vue?vue&type=template&id=19b0ade0&scoped=true"
import script from "./behno-press.vue?vue&type=script&lang=js"
export * from "./behno-press.vue?vue&type=script&lang=js"

import "./behno-press.vue?vue&type=style&index=0&id=19b0ade0&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b0ade0"]])

export default __exports__